import $ from 'jquery';
import searchForm from './components/search-form';
import App from './components/app';

require('./components/publish-jquery');
require('./components/subscribe-block');
require('./components/show_locations');
require('./components/lazy-load')
require('./components/collapsible');
require('./components/overflow-slider');
require('./components/scroll-to-top');

window.$ = $;

// require('bootstrap/tab');
// require('bootstrap/tooltip');
// require('bootstrap/collapse');
// require('bootstrap/dropdown');
// require('bootstrap/modal');
// require('jquery-ui/ui/position');
// require('jquery-ui/ui/keycode');
// require('jquery-ui/ui/unique-id');
// require('jquery-ui/ui/widget');
// require('jquery-ui/ui/widgets/menu');
// require('jquery-ui/ui/widgets/autocomplete');
// require('jquery-ui/ui/widgets/datepicker');


esquire.define('search.form', searchForm);
esquire.define('App', App);
